import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import Select from "react-select";
import { Link } from "react-router-dom";
import axios from "../api/axios";
import jwt_decode from "jwt-decode";
import { SERVER_URL } from "../ServerLink";
import { useDispatch } from "react-redux";
import moment from "moment";
import FeatherIcon from "feather-icons-react";

import {
  Button,
  UncontrolledCollapse,
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  CardHeader,
  Collapse,
  Label,
  Form,
  Input,
  Pagination,
  PaginationItem,
  PaginationLink,
  ModalFooter,
  ModalBody,
  ModalHeader,
  InputGroup,
  CardTitle,
  FormGroup,
} from "reactstrap";
import Dropzone from "react-dropzone";
import Switch from "react-switch";
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { toast } from "react-toastify";
import UploadLogo from "../../assets/images/imgSymboleLogo.jpg";
import { isLoading } from "../../store/actions";
import { EditProperty } from "../V2/Property/EditProperty";
import { DocumentPreviewUI, canPreviewFile, cleanFileName } from "../V2/Property/Helpers/DocumentRenderer";
import { formatBytes } from "../digi/ResidentApplicationForm/Helpers";

const SUITE_TYPES = [
  { id: 1, title: "Studio Suite", value: "Studio Suite" },
  { id: 2, title: "1-Bedroom Suite", value: "1-Bedroom Suite" },
  { id: 3, title: "2-Bedroom Suite", value: "2-Bedroom Suite" },
  { id: 4, title: "Penthouse Suite", value: "Penthouse Suite" },
  { id: 5, title: "Loft Suite", value: "Loft Suite" },
  { id: 6, title: "Office Suite", value: "Office Suite" },
  { id: 7, title: "Retail Suite", value: "Retail Suite" },
  { id: 8, title: "Executive Suite", value: "Executive Suite" },
  { id: 9, title: "Medical Suite", value: "Medical Suite" },
  { id: 10, title: "Conference Suite", value: "Conference Suite" },
  { id: 11, title: "Residential-Commercial Suite", value: "Residential-Commercial Suite" },
  { id: 12, title: "Hotel Suite", value: "Hotel Suite" },
];

const PARKING_TYPES = [
  { id: 1, title: "UG Parking", value: "UG Parking" },
  { id: 2, title: "SS Parking", value: "SS Parking" },
];

const FLOOR_LIMIT_FROM = 1;
const FLOOR_LIMIT_TO = 100;
const ALPHABET = [
  "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
  "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
];

const STORAGE_TYPES = [
  { id: 1, title: "UG Storage", value: "UG Storage" },
  { id: 2, title: "SS Storage", value: "SS Storage" },
];

const AddProperty = (props) => {
  const dispatch = useDispatch();
  const decode = jwt_decode(window.localStorage.accessToken);
  const decode2 = jwt_decode(window.localStorage.getItem("accessToken"));

  const GET_COMPANIES_URL = "/company";
  const GET_LAYOUT_URL = "/layout/all";
  const ADD_PROPERTY_URL = "/property/add";
  const POST_PROPERTY_LOGO = "/property/upload-logo/";
  const POST_IMAGE_URL = "/property1/img";
  const FILTER_URL = `/property/filter?role=${decode2.role}&domain=${decode2.role == "manager" ? decode2.id : decode2.domain
    }`;
  const GET_SUITE_DETAILS = "/suite/suite-details";
  const GET_PARKING_DETAILS = "/parking/parking-details";
  const GET_STORAGE_DETAILS = "/storage/storage-details";

  // ─── Document state (mirrors DocumentsHandler) ───────────────────────────
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFileForPreview, setSelectedFileForPreview] = useState(null);
  const [isDragActive, setIsDragActive] = useState(false);

  // Edit-filename modal state
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editingFile, setEditingFile] = useState(null);
  const [editedFileName, setEditedFileName] = useState("");
  const [editFileIndex, setEditFileIndex] = useState(null);

  // ─── Other existing state ─────────────────────────────────────────────────
  const [companyList, setCompanyList] = useState([]);
  const [editData, seteditData] = useState(false);
  const [title, setTitle] = useState("");
  const [landload, setLandload] = useState("");
  const [rent, setRent] = useState("");
  const [postal, setPostal] = useState("");
  const [address, setAddress] = useState("");
  const [category, setCategory] = useState([]);
  const [location, setLocation] = useState("");
  const [status, setStatus] = useState("");
  const [totalcompanies, settotalcompanies] = useState(0);
  const [active, setActive] = useState(0);
  const [totalproperties, settotalproperties] = useState([]);
  const [layout, setLayout] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [pages, setPages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [manager, setManager] = useState([]);
  const [locationn, setlocationn] = useState([]);
  const [company, setCompany] = useState([]);
  const [propertyname, setPropertyname] = useState([]);
  const [startDate, setstartDate] = useState("");
  const [check_title, setcheck_title] = useState(true);
  const [check_landload, setcheck_landload] = useState(true);
  const [suite, setSuite] = useState(false);
  const [parking, setParking] = useState(false);
  const [storage, setStorage] = useState(false);
  const [check_rent, setcheck_rent] = useState(true);
  const [check_postal, setcheck_postal] = useState(true);
  const [check_address, setcheck_address] = useState(true);
  const [check_layout, setcheck_layout] = useState(true);
  const [check_city, setcheck_city] = useState(true);
  const [check_status, setcheck_status] = useState(true);
  const [check_document, setcheck_document] = useState(true);
  const [filterData, setFilterData] = useState(null);
  const [msg_error, setmsg_error] = useState("");
  const [msg_error_landload, setmsg_error_landload] = useState("");
  const [msg_error1, setmsg_error1] = useState("");
  const [msg_error2, setmsg_error2] = useState("");
  const [msg_error3, setmsg_error3] = useState("");
  const [msg_error4, setmsg_error4] = useState("");
  const [rent_error, setrent_error] = useState("");
  const [postal_error, setpostal_error] = useState("");
  const [address_error, setaddress_error] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteDialoge, setShowDeleteDialoge] = useState(false);
  const [modal_largee2, setmodal_largee2] = useState(false);
  const [logoIsOpen, setLogoIsOpen] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [previewLogoUrl, setPreviewLogoUrl] = useState("");
  const [updateLogoUrl, setUpdateLogoUrl] = useState(null);
  const [propertyID, setPropertyID] = useState("");
  const [selectPropertyManager, setSelectPropertyManager] = useState(null);
  const [selectPropertyName, setSelectPropertyName] = useState(null);
  const [page, setPage] = useState();
  const [stats, setStats] = useState({ Total: 0, Active: 0, Inactive: 0 });
  const [startPage, setStartPage] = useState(1);
  const pageTotal = Math.ceil(stats.Total / pageLimit);
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (id) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };

  const [suiteType, setSuiteType] = useState(SUITE_TYPES[0].value);
  const [suiteData, setSuiteData] = useState([]);
  const [isSuiteAlphabet, setIsSuiteAlphabet] = useState([]);

  const [parkingType, setParkingType] = useState(PARKING_TYPES[0].value);
  const [parkingData, setParkingData] = useState([]);
  const [isAlphabet, setIsAlphabet] = useState([]);

  const [storageType, setStorageType] = useState(STORAGE_TYPES[0].value);
  const [storageData, setStorageData] = useState([]);
  const [isStorageAlphabet, setIsStorageAlphabet] = useState([]);

  // ─── Table document preview modal state ──────────────────────────────────
  const GET_PREVIEW_URL = "/property/get-content";
  const BASE_SPACES_URL = "https://rentdigicare.tor1.digitaloceanspaces.com/";

  const [docPreviewModal, setDocPreviewModal] = useState(false);
  const [docPreviewItem, setDocPreviewItem] = useState(null);   // { url, fileName }
  const [docPreviewSignedUrl, setDocPreviewSignedUrl] = useState(null);
  const [docPreviewLoading, setDocPreviewLoading] = useState(false);
  const [docPreviewError, setDocPreviewError] = useState(null);

  const openDocPreview = async (doc) => {
    // Open the modal immediately so the user sees something happening
    setDocPreviewItem(doc);
    setDocPreviewSignedUrl(null);
    setDocPreviewError(null);
    setDocPreviewLoading(true);
    setDocPreviewModal(true);

    try {
      // Strip the base URL to get the relative path, matching DocumentsHandler exactly
      const relativePath = doc.url.replace(BASE_SPACES_URL, "");
      const { data } = await axios.get(GET_PREVIEW_URL, {
        params: { fileUrl: relativePath },
      });
      setDocPreviewSignedUrl(data.signedUrl);
    } catch (err) {
      console.error("Error fetching signed URL for preview:", err);
      setDocPreviewError("Failed to load preview. You can still open the file in a new tab.");
    } finally {
      setDocPreviewLoading(false);
    }
  };

  const closeDocPreview = () => {
    setDocPreviewModal(false);
    setDocPreviewItem(null);
    setDocPreviewSignedUrl(null);
    setDocPreviewError(null);
    setDocPreviewLoading(false);
  };

  // ─── Cleanup object URLs on unmount ──────────────────────────────────────
  useEffect(() => {
    return () => {
      selectedFiles.forEach((f) => {
        if (f.preview && typeof f.preview !== "string") {
          URL.revokeObjectURL(f.preview);
        }
      });
    };
  }, [selectedFiles]);

  // ─── Document helper functions (mirrors DocumentsHandler) ─────────────────

  const getDisplayName = (file) => {
    return (
      file.name ||
      cleanFileName(file?.originalUrl?.split("/").pop() || "") ||
      "Unnamed File"
    );
  };

  const handleAcceptedFiles = (acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) => {
      const fileExt = file.name.split(".").pop().toLowerCase();
      return {
        file,
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
        name: file.name,
        originalName: file.name,
        fileType: fileExt,
      };
    });

    setSelectedFiles((prev) => [...prev, ...newFiles]);
    setcheck_document(true);
    setmsg_error1("");
    setIsDragActive(false);
  };

  const handleRemoveFile = (fileToRemove) => {
    setSelectedFiles((prev) => {
      const updated = prev.filter(
        (item) =>
          item.preview !== fileToRemove.preview &&
          item.originalUrl !== fileToRemove.originalUrl
      );
      return updated;
    });

    if (fileToRemove.preview && typeof fileToRemove.preview !== "string") {
      URL.revokeObjectURL(fileToRemove.preview);
    }

    if (
      selectedFileForPreview &&
      (selectedFileForPreview.preview === fileToRemove.preview ||
        selectedFileForPreview.originalUrl === fileToRemove.originalUrl)
    ) {
      setSelectedFileForPreview(null);
    }
  };

  const handlePreviewFile = (file) => {
    setSelectedFileForPreview((prev) => (prev === file ? null : file));
  };

  const openEditModal = (file, index) => {
    setEditingFile(file);
    setEditedFileName(file.name || "");
    setEditFileIndex(index);
    setEditModalOpen(true);
  };

  const saveEditedFileName = () => {
    if (!editedFileName.trim()) return;

    setSelectedFiles((prev) => {
      const updated = [...prev];
      const originalExt = editingFile.originalName
        ? `.${editingFile.originalName.split(".").pop()}`
        : editingFile.fileType
          ? `.${editingFile.fileType}`
          : "";

      let newName = editedFileName;
      if (originalExt && !newName.endsWith(originalExt)) {
        newName = newName.split(".")[0] + originalExt;
      }

      updated[editFileIndex] = { ...updated[editFileIndex], name: newName };
      return updated;
    });

    setEditModalOpen(false);
  };

  // ─── Validation helpers ───────────────────────────────────────────────────

  const isSuiteDataValid = () => {
    let _suiteData = suiteData.slice();
    if (_suiteData.length > 0) {
      let validArray = [];
      _suiteData.forEach((item, index) => {
        item.floors.forEach((_item, _index) => {
          if (_item.from && _item.to) {
            if (isSuiteAlphabet[index][_index]) {
              validArray.push(!!_item.alphabet);
            } else {
              validArray.push(true);
            }
          } else {
            validArray.push(false);
          }
        });
      });
      return !validArray.includes(false);
    }
    return true;
  };

  const isPrarkingDataValid = () => {
    let _parkingData = parkingData.slice();
    if (_parkingData.length > 0) {
      let validArray = [];
      _parkingData.map((item, index) => {
        item.floors.map((_item, _index) => {
          if (_item.from && _item.to) {
            if (isAlphabet[index][_index]) {
              validArray.push(!!_item.alphabet);
            } else {
              validArray.push(true);
            }
          } else {
            validArray.push(false);
          }
        });
      });
      return !validArray.includes(false);
    }
    return true;
  };

  const isStorageDataValid = () => {
    let _parkingData = storageData.slice();
    if (_parkingData.length > 0) {
      let validArray = [];
      _parkingData.map((item, index) => {
        item.floors.map((_item, _index) => {
          if (_item.from && _item.to) {
            if (isStorageAlphabet[index][_index]) {
              validArray.push(!!_item.alphabet);
            } else {
              validArray.push(true);
            }
          } else {
            validArray.push(false);
          }
        });
      });
      return !validArray.includes(false);
    }
    return true;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedLogo(file);
    const previewURL = URL.createObjectURL(file);
    setPreviewLogoUrl(previewURL);
  };

  const handleUploadLogo = async () => {
    try {
      if (!selectedLogo) return;
      const formData = new FormData();
      formData.append("logoFile", selectedLogo);
      const responce = await axios.post(POST_PROPERTY_LOGO + propertyID, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (responce.data.status === 200) {
        toast.success("Logo Upload Successfully.");
        setSelectedLogo(null);
        setPropertyID("");
        setLogoIsOpen(false);
        setUpdateLogoUrl("");
        setPreviewLogoUrl("");
        getProperties();
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  function removeBodyCss2() {
    document.body.classList.add("no_padding");
  }

  function tog_largee2() {
    setmodal_largee2(!modal_large2);
    removeBodyCss2();
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (page > startPage + pageLimit - 1 || page < startPage) {
      setStartPage(Math.max(1, page - pageLimit / 2));
    }
  };

  const dataFilter = async () => {
    let temp = await axios.get(FILTER_URL);
    setCompany(temp?.data?.properties[0]?.company);
    setCategories(temp?.data?.properties[0]?.category);
    setManager(temp?.data?.properties[0]?.manager);
    setlocationn(temp?.data?.properties[0]?.location);
    setPropertyname(temp?.data?.properties[0]?.property_name);
  };

  const PROPERTIES_URL = `/property/list?page=${currentPage}&limit=10`;
  const decode1 = jwt_decode(window.localStorage.getItem("accessToken"));

  useEffect(() => {
    dataFilter();
    let total_pages = totalcompanies / pageLimit;
    if (totalcompanies % pageLimit == 0) {
      setPages(Array.from(Array(Math.round(total_pages)).keys()));
    } else {
      setPages(Array.from(Array(parseInt(total_pages) + 1).keys()));
    }
  }, [totalcompanies]);

  useEffect(() => {
    if (props.location?.state?.name !== undefined) {
      getProperties(0, { manager: props.location?.state?.name });
      window.history.replaceState(null, "");
    } else {
      getProperties();
    }
    let total_pages = totalcompanies / pageLimit;
    if (totalcompanies % pageLimit == 0) {
      setPages(Array.from(Array(Math.round(total_pages)).keys()));
    } else {
      setPages(Array.from(Array(parseInt(total_pages) + 1).keys()));
    }
  }, [currentPage, props.location?.state?.name]);

  async function getCompanies() {
    try {
      const response = await axios.get(GET_COMPANIES_URL);
      setCompanyList(response.data.companies);
    } catch (error) {
      console.log(error);
    }
  }

  async function getLayout(url, data) {
    try {
      const response = await axios.post(url, data);
      response.data.layouts.forEach((element) => {
        setLayout((current) => [
          ...current,
          { label: element.layoutName, value: element._id },
        ]);
      });
    } catch (error) {
      console.log(error);
    }
  }

  const handleCloseModal = () => {
    tog_large();
    setcheck_title(true);
    setcheck_rent(true);
    setcheck_layout(true);
    setcheck_city(true);
    setcheck_status(true);
    setcheck_postal(true);
    seteditData(false);
    setTitle("");
    setLocation("");
    setStatus("");
    setRent("");
    setPostal("");
    setCategory([]);
    setSelectedFiles([]);
    setSelectedFileForPreview(null);
    setPropertyID("");
  };

  async function addProperty(event) {
    event.preventDefault();

    if (!title) {
      setcheck_title(false);
      setmsg_error("Property Name is required!");
    } else {
      setcheck_title(true);
    }

    if (title) {
      if (!title.match(/^[a-zA-Z0-9 ]+$/)) {
        setcheck_title(false);
        setmsg_error("Only Letters And Numbers Are Allowed");
      } else {
        setcheck_title(true);
      }
    }

    if (!rent) {
      setcheck_rent(false);
      setrent_error("Rent is required!");
    } else {
      if (!rent.match(/^[0-9 ]+$/)) {
        setcheck_rent(false);
        setrent_error("Only Numbers Are Allowed");
      } else {
        setcheck_rent(true);
      }
    }

    if (!postal) {
      setcheck_postal(false);
      setpostal_error("Postal code is required!");
    } else {
      setcheck_postal(true);
    }

    if (!address) {
      setcheck_address(false);
      setaddress_error("Address is required!");
    } else {
      setcheck_address(true);
    }

    if (!location) {
      setcheck_city(false);
      setmsg_error3("City required!");
    } else {
      setcheck_city(true);
    }

    if (location) {
      if (!location.match(/^[a-zA-Z0-9 ]+$/)) {
        setcheck_city(false);
        setmsg_error3("Only letters and numbers are allowed!");
      } else {
        setcheck_city(true);
      }
    }

    if (category.length <= 0) {
      setcheck_layout(false);
      setmsg_error2("Please select a Layout!");
    } else {
      setcheck_layout(true);
    }

    if (!status) {
      setcheck_status(false);
      setmsg_error4("Please select a Status!");
    } else {
      setcheck_status(true);
    }

    if (
      title &&
      check_title &&
      category.length > 0 &&
      check_layout &&
      location &&
      check_city &&
      status &&
      check_rent &&
      check_status &&
      postal &&
      check_postal &&
      check_address &&
      address &&
      check_landload
    ) {
      const decode = jwt_decode(window.localStorage.getItem("accessToken"));
      if (!editData) {
        try {
          if (!isPrarkingDataValid()) return;
          if (!isStorageDataValid()) return;

          const saveSpinner = document.getElementById("saveSpinner");
          const failedSaveErrorIcon = document.getElementById("failedSaveErrorIcon");
          const nexticon = document.getElementById("nexticon");

          saveSpinner.style.display = "inline-block";
          failedSaveErrorIcon.style.display = "none";
          nexticon.style.display = "none";

          const response = await axios.post(ADD_PROPERTY_URL, {
            title,
            companyID: decode.id,
            company: decode.company,
            companyDomain: decode.domain,
            category: category?.map((c) => c.value),
            owner: decode.firstname + " " + decode.lastname,
            rent,
            postal,
            address,
            location,
            status,
            manager: [],
            documents: [],
            parkingData,
            storageData,
            landlord: landload,
          });

          if (response) {
            toast.success(response.data.messsage);
            await uploadDocuments(response.data.id);
            handleCloseModal();
            resetSuiteForm();
            resetParkingForm();
            resetStorageForm();
            getProperties();

            saveSpinner.style.display = "none";
            failedSaveErrorIcon.style.display = "none";
            nexticon.style.display = "inline-block";
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        editProperty();
      }
    }
  }

  const EDIT_PROPERTY_URL = `/property/update/${propertyID}`;

  const editProperty = async () => {
    try {
      if (!isSuiteDataValid()) return;
      if (!isPrarkingDataValid()) return;
      if (!isStorageDataValid()) return;

      setLoading(true);

      const res = await axios.post(EDIT_PROPERTY_URL, {
        title,
        companyID: decode.id,
        company: decode.company,
        companyDomain: decode.domain,
        category: category.map((c) => c.value),
        owner: decode.firstname + " " + decode.lastname,
        rent_amount: rent,
        postal_code: postal,
        address,
        location,
        status,
        documents: [],
        suiteData,
        parkingData,
        storageData,
        landlord: landload,
      });

      if (res) {
        selectedFiles?.length > 0 && (await uploadDocuments(res.data.id));
        toast.success(res.data.message);
        resetParkingForm();
        resetStorageForm();
        handleCloseModal();
        getProperties();
        setLoading(false);
      }
    } catch (e) {
      console.log("error", e.message);
      setLoading(false);
    }
  };

  const [modal_large, setmodal_large] = useState(false);
  const [modal_large1, setmodal_large1] = useState(false);
  const [modal_large2, setmodal_large2] = useState(false);

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  function tog_large() {
    setmodal_large(!modal_large);
    removeBodyCss();
  }
  function tog_large1() {
    setmodal_large1(!modal_large1);
    removeBodyCss();
  }
  function tog_large2() {
    setmodal_large2(!modal_large2);
    removeBodyCss();
  }

  const [col5, setcol5] = useState(false);
  const t_col5 = () => setcol5(!col5);

  useState(async () => {
    if (decode.role === "company") {
      await getLayout(GET_LAYOUT_URL, { companyID: decode.id });
    }
  });

  const filterDataHandle = (e, name, data) => {
    let newData = { ...filterData };
    newData[name] = data;
    setFilterData(newData);
  };

  const onchangetext = (e, name) => {
    let newData = { ...filterData };
    if (name === "propertyId") {
      newData[name] = e.target.value;
    } else if (name === "To") {
      newData["dateRange"] = `${startDate}=${e.target.value}`;
    } else {
      newData[name] = "";
    }
    setFilterData(newData);
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  async function uploadDocuments(val) {
    const formData = new FormData();
    // Use the file objects from our enriched selectedFiles array
    selectedFiles.forEach((f) => {
      if (f.file instanceof File) {
        formData.append("file", f.file);
      } else {
        formData.append("file", f);
      }
    });

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        id: `${val}`,
      },
    };

    try {
      await axios.post("/property/upload-documents", formData, config);
    } catch (error) { }
  }

  const getProperties = async (sorting, custom) => {
    if (filterData !== null) setCurrentPage(1);

    let data = {
      role: decode1.role,
      domain: decode1.domain,
      managerID: decode1.id,
      filter: custom ? custom : filterData,
      sort: sorting,
    };

    try {
      dispatch(isLoading(true));
      const response = await axios.post(PROPERTIES_URL, data);
      if (response.data.results.properties) {
        const temp = response.data.results.properties;
        settotalproperties(temp);
        setPage(
          response.data.results.previous
            ? response.data.results.previous.page + 1
            : 1
        );
        settotalcompanies(response.data.totalProperties);
        setActive(response.data.totalActiveProperties);
        setStats((prev) => ({
          ...prev,
          Total: response.data.total.Total || 0,
          Active: response.data.total.Active || 0,
          Inactive: response.data.total.Inactive || 0,
        }));
        dispatch(isLoading(false));
      }
    } catch (error) {
      console.log(error);
      dispatch(isLoading(false));
    }
  };

  const handleSorting = (e) => {
    let value = [1, -1];
    let newData = {};
    if (e.target.value == 1) newData["title"] = value[0];
    else if (e.target.value == 2) newData["title"] = value[1];
    else if (e.target.value == 3) newData["createdAt"] = value[1];
    else if (e.target.value == 4) newData["createdAt"] = value[0];
    else if (e.target.value == 5) newData["modifiedAt"] = value[1];
    else if (e.target.value == 6) newData["modifiedAt"] = value[0];
    else newData[" "] = " ";
    getProperties(newData);
  };

  async function deleteProperty() {
    try {
      const response = await axios.delete(
        `/property/delete?userID=${decode2.id}&propertyID=${propertyID}`
      );
      if (response.data.status === 200) {
        toast.success(response.data.message);
        setPropertyID("");
        getProperties();
        setShowDeleteDialoge(false);
      } else {
        toast.warning(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  let number = 0;
  let number1 = page > 1 ? (page - 1) * 10 : 0;

  // ─── Parking Functionality ────────────────────────────────────────────────
  const handleOnSelectParkingType = (event) => setParkingType(event.target.value);

  const handleAddParkingType = () => {
    let _parkingData = parkingData.slice();
    if (
      _parkingData.length <= 2 &&
      _parkingData.findIndex((doc) => doc.floorType == parkingType) == -1
    ) {
      _parkingData.push({
        floorType: parkingType,
        floorCount: FLOOR_LIMIT_FROM,
        floors: [{ floor: "1 Floor", from: "", to: "" }],
      });
      setParkingData(_parkingData);
      let _isAlphabet = isAlphabet.slice();
      _isAlphabet.push([false]);
      setIsAlphabet(_isAlphabet);
    }
  };

  const handleRemoveParkingType = (index) => {
    let _parkingData = parkingData.slice();
    _parkingData.splice(index, 1);
    setParkingData(_parkingData);
    let _isAlphabet = isAlphabet.slice();
    _isAlphabet.splice(index, 1);
    setIsAlphabet(_isAlphabet);
  };

  const handleIncreaseFloor = (index) => {
    let _parkingData = parkingData.slice();
    if (_parkingData.length > 0) {
      let _floorCount = _parkingData[index].floorCount;
      if (_floorCount >= FLOOR_LIMIT_FROM && _floorCount <= FLOOR_LIMIT_TO) {
        _floorCount++;
        const _floorDetail = _parkingData[index].floors.slice();
        _floorDetail.push({ floor: `${_floorCount} Floor`, from: "", to: "" });
        _parkingData[index].floorCount = _floorCount;
        _parkingData[index].floors = _floorDetail;
        setParkingData(_parkingData);
        let _isAlphabet = isAlphabet.slice();
        _isAlphabet[index].push(false);
        setIsAlphabet(_isAlphabet);
      }
    }
  };

  const handleDecreaseFloor = (index) => {
    let _parkingData = parkingData.slice();
    if (_parkingData.length > 0) {
      let _floorCount = _parkingData[index].floorCount;
      if (_floorCount >= FLOOR_LIMIT_FROM) {
        _floorCount--;
        const _floorDetail = _parkingData[index].floors.slice();
        _floorDetail.pop();
        _parkingData[index].floorCount = _floorCount;
        _parkingData[index].floors = _floorDetail;
        setParkingData(_parkingData);
        let _isAlphabet = isAlphabet.slice();
        _isAlphabet[index].pop();
        setIsAlphabet(_isAlphabet);
      }
    }
  };

  const handleOnChnageOnFloor = (event, index, _index) => {
    const { name, value } = event.target;
    let _parkingData = parkingData.slice();
    if (_parkingData.length > 0) {
      const _floorDetail = _parkingData[index].floors.slice();
      _floorDetail[_index][name] = value;
      _parkingData[index].floors = _floorDetail;
      setParkingData(_parkingData);
    }
  };

  const resetParkingForm = () => {
    setParking(false);
    setParkingData([]);
    setIsAlphabet([]);
  };

  const getParkingDetails = async (id) => {
    try {
      const response = await axios.get(`${GET_PARKING_DETAILS}?id=${id}`);
      if (
        response.data.data &&
        response.data.data.parkingData &&
        response.data.data.parkingData.length
      ) {
        const _result = response.data.data.parkingData;
        setParking(true);
        setParkingData(_result);
        const _isAlphabet = _result.map((item) =>
          item.floors.map((_item) => _item.alphabet !== "")
        );
        setIsAlphabet(_isAlphabet);
      } else {
        resetParkingForm();
      }
    } catch (error) { }
  };

  // ─── Suite Functionality ──────────────────────────────────────────────────
  const handleOnSelectSuiteType = (event) => setSuiteType(event.target.value);

  const handleAddSuiteType = () => {
    let _suiteData = suiteData.slice();
    if (
      _suiteData.length <= 2 &&
      _suiteData.findIndex((doc) => doc.floorType == suiteType) == -1
    ) {
      _suiteData.push({
        floorType: suiteType,
        floorCount: FLOOR_LIMIT_FROM,
        floors: [{ floor: "1 Floor", from: "", to: "" }],
      });
      setSuiteData(_suiteData);
      let _isAlphabet = isSuiteAlphabet.slice();
      _isAlphabet.push([false]);
      setIsSuiteAlphabet(_isAlphabet);
    }
  };

  const handleRemoveSuiteType = (index) => {
    let _suiteData = suiteData.slice();
    _suiteData.splice(index, 1);
    setSuiteData(_suiteData);
    let _isAlphabet = isSuiteAlphabet.slice();
    _isAlphabet.splice(index, 1);
    setIsSuiteAlphabet(_isAlphabet);
  };

  const handleIncreaseSuiteFloor = (index) => {
    let _suiteData = suiteData.slice();
    if (_suiteData.length > 0) {
      let _floorCount = _suiteData[index].floorCount;
      if (_floorCount >= FLOOR_LIMIT_FROM && _floorCount <= FLOOR_LIMIT_TO) {
        _floorCount++;
        const _floorDetail = _suiteData[index].floors.slice();
        _floorDetail.push({ floor: `${_floorCount} Floor`, from: "", to: "" });
        _suiteData[index].floorCount = _floorCount;
        _suiteData[index].floors = _floorDetail;
        setSuiteData(_suiteData);
        let _isAlphabet = isSuiteAlphabet.slice();
        _isAlphabet[index].push(false);
        setIsSuiteAlphabet(_isAlphabet);
      }
    }
  };

  const handleDecreaseSuiteFloor = (index) => {
    let _suiteData = suiteData.slice();
    if (_suiteData.length > 0) {
      let _floorCount = _suiteData[index].floorCount;
      if (_floorCount >= FLOOR_LIMIT_FROM) {
        _floorCount--;
        const _floorDetail = _suiteData[index].floors.slice();
        _floorDetail.pop();
        _suiteData[index].floorCount = _floorCount;
        _suiteData[index].floors = _floorDetail;
        setSuiteData(_suiteData);
        let _isAlphabet = isSuiteAlphabet.slice();
        _isAlphabet[index].pop();
        setIsSuiteAlphabet(_isAlphabet);
      }
    }
  };

  const handleOnSuiteChangeOnFloor = (event, index, _index) => {
    const { name, value } = event.target;
    let _suiteData = suiteData.slice();
    if (_suiteData.length > 0) {
      const _floorDetail = _suiteData[index].floors.slice();
      _floorDetail[_index][name] = value;
      _suiteData[index].floors = _floorDetail;
      setSuiteData(_suiteData);
    }
  };

  const resetSuiteForm = () => {
    setSuiteType(SUITE_TYPES[0].value);
    setSuiteData([]);
    setIsSuiteAlphabet([]);
  };

  const getSuiteDetails = async (id) => {
    try {
      const response = await axios.get(`${GET_SUITE_DETAILS}?id=${id}`);
      if (
        response.data.data &&
        response.data.data.suiteData &&
        response.data.data.suiteData.length
      ) {
        const _result = response.data.data.suiteData;
        setSuiteType(SUITE_TYPES[0].value);
        setSuiteData(_result);
        const _isAlphabet = _result.map((item) =>
          item.floors.map((_item) => _item.alphabet !== "")
        );
        setIsSuiteAlphabet(_isAlphabet);
      } else {
        resetSuiteForm();
      }
    } catch (error) { }
  };

  // ─── Storage Functionality ────────────────────────────────────────────────
  const handleOnSelectStorageType = (event) => setStorageType(event.target.value);

  const handleAddStorageType = () => {
    let _parkingData = storageData.slice();
    if (
      _parkingData.length <= 2 &&
      _parkingData.findIndex((doc) => doc.floorType == storageType) == -1
    ) {
      _parkingData.push({
        floorType: storageType,
        floorCount: FLOOR_LIMIT_FROM,
        floors: [{ floor: "1 Floor", from: "", to: "" }],
      });
      setStorageData(_parkingData);
      let _isAlphabet = isStorageAlphabet.slice();
      _isAlphabet.push([false]);
      setIsStorageAlphabet(_isAlphabet);
    }
  };

  const handleRemoveStorageType = (index) => {
    let _parkingData = storageData.slice();
    _parkingData.splice(index, 1);
    setStorageData(_parkingData);
    let _isAlphabet = isStorageAlphabet.slice();
    _isAlphabet.splice(index, 1);
    setIsStorageAlphabet(_isAlphabet);
  };

  const handleIncreaseStorageFloor = (index) => {
    let _parkingData = storageData.slice();
    if (_parkingData.length > 0) {
      let _floorCount = _parkingData[index].floorCount;
      if (_floorCount >= FLOOR_LIMIT_FROM && _floorCount <= FLOOR_LIMIT_TO) {
        _floorCount++;
        const _floorDetail = _parkingData[index].floors.slice();
        _floorDetail.push({ floor: `${_floorCount} Floor`, from: "", to: "" });
        _parkingData[index].floorCount = _floorCount;
        _parkingData[index].floors = _floorDetail;
        setStorageData(_parkingData);
        let _isAlphabet = isStorageAlphabet.slice();
        _isAlphabet[index].push(false);
        setIsStorageAlphabet(_isAlphabet);
      }
    }
  };

  const handleDecreaseStorageFloor = (index) => {
    let _parkingData = storageData.slice();
    if (_parkingData.length > 0) {
      let _floorCount = _parkingData[index].floorCount;
      if (_floorCount >= FLOOR_LIMIT_FROM) {
        _floorCount--;
        const _floorDetail = _parkingData[index].floors.slice();
        _floorDetail.pop();
        _parkingData[index].floorCount = _floorCount;
        _parkingData[index].floors = _floorDetail;
        setStorageData(_parkingData);
        let _isAlphabet = isStorageAlphabet.slice();
        _isAlphabet[index].pop();
        setIsStorageAlphabet(_isAlphabet);
      }
    }
  };

  const handleOnStorageChangeOnFloor = (event, index, _index) => {
    const { name, value } = event.target;
    let _parkingData = storageData.slice();
    if (_parkingData.length > 0) {
      const _floorDetail = _parkingData[index].floors.slice();
      _floorDetail[_index][name] = value;
      _parkingData[index].floors = _floorDetail;
      setStorageData(_parkingData);
    }
  };

  const resetStorageForm = () => {
    setStorage(false);
    setStorageData([]);
    setIsStorageAlphabet([]);
  };

  const getStorageDetails = async (id) => {
    try {
      const response = await axios.get(`${GET_STORAGE_DETAILS}?id=${id}`);
      if (
        response.data.data &&
        response.data.data.storageData &&
        response.data.data.storageData.length
      ) {
        const _result = response.data.data.storageData;
        setStorage(true);
        setStorageData(_result);
        const _isAlphabet = _result.map((item) =>
          item.floors.map((_item) => _item.alphabet !== "")
        );
        setIsStorageAlphabet(_isAlphabet);
      } else {
        resetStorageForm();
      }
    } catch (error) { }
  };

  // ─── Render ───────────────────────────────────────────────────────────────

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> Rentdigicare | Property</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Property" />
          <Row>
            <Col xl={12}>
              <Card>
                <CardHeader>
                  <div className="row align-items-center">
                    <div className="col-md-6 d-flex">
                      <div className="mb mx-2">
                        <h5 className="card-title">
                          Total
                          <span className="text-muted fw-normal ms-1">({stats?.Total})</span>
                        </h5>
                      </div>
                      <div className="mb mx-2">
                        <h5 className="card-title">
                          Active
                          <span className="text-muted fw-normal ms-1">({stats?.Active})</span>
                        </h5>
                      </div>
                      <div className="mb mx-2">
                        <h5 className="card-title">
                          Inactive
                          <span className="text-muted fw-normal ms-1">({stats?.Inactive})</span>
                        </h5>
                      </div>
                    </div>

                    <div className="col-md-6 d-flex flex-wrap align-items-center justify-content-end">
                      <div className="mb">
                        <button
                          onClick={t_col5}
                          className="btn btn-primary mo-mb-2 mr-10"
                          type="button"
                          style={{ cursor: "pointer" }}
                        >
                          Filters
                        </button>
                        {!(decode.role === "manager" || decode.role === "admin") ? (
                          <button
                            type="button"
                            onClick={async () => {
                              tog_large();
                              await getCompanies();
                              resetParkingForm();
                              resetStorageForm();
                              setLandload("");
                            }}
                            className="btn btn-light "
                            data-toggle="modal"
                            data-target=".bs-example-modal-lg"
                          >
                            <i className="bx bx-plus me-1"></i> Add Property
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <Collapse className="mt-4" isOpen={col5}>
                        <Card>
                          <CardBody>
                            <div className="filter-sec">
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  getProperties();
                                }}
                              >
                                <div className="row align-items-center">
                                  {decode2.role === "admin" ? (
                                    <div className="col-md-4">
                                      <div className="mb-3">
                                        <Label className="form-Label">Company Name</Label>
                                        <select
                                          className="form-select"
                                          onChange={(e) =>
                                            filterDataHandle(e, "company", e.target.value)
                                          }
                                        >
                                          <option value="">Select One</option>
                                          {company &&
                                            company.map((item) => (
                                              <option key={item.id} value={item.id}>
                                                {item.name}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                    </div>
                                  ) : null}

                                  <div className="col-md-4">
                                    <div className="mb-3">
                                      <Label className="form-Label">Property Name</Label>
                                      <Select
                                        value={selectPropertyName}
                                        options={propertyname?.map((item) => ({
                                          value: item.title,
                                          label: item.title,
                                        }))}
                                        placeholder="Search By Name"
                                        onChange={(e) => {
                                          setSelectPropertyName(e);
                                          filterDataHandle(e, "title", e.value);
                                        }}
                                      />
                                    </div>
                                  </div>

                                  {decode2.role !== "manager" && (
                                    <div className="col-md-4">
                                      <div className="mb-3">
                                        <Label className="form-Label">Property Manager</Label>
                                        <Select
                                          value={selectPropertyManager}
                                          options={
                                            manager?.map((item) => ({
                                              value: item._id,
                                              label: item.firstname + item.lastname,
                                            })) || []
                                          }
                                          placeholder="Search By Name"
                                          onChange={(e) => {
                                            setSelectPropertyManager(e);
                                            filterDataHandle(e, "manager", e.value);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}

                                  <div className="col-md-4">
                                    <div className="mb-3">
                                      <Label className="form-Label">City</Label>
                                      <select
                                        className="form-select"
                                        onChange={(e) =>
                                          filterDataHandle(e, "location", e.target.value)
                                        }
                                      >
                                        <option value="">Select One</option>
                                        {locationn &&
                                          locationn.map((item) => (
                                            <option key={item.location} value={item.location}>
                                              {item.location}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="mb-3">
                                      <Label className="form-Label">Status</Label>
                                      <select
                                        className="form-select"
                                        onChange={(e) =>
                                          filterDataHandle(e, "status", e.target.value)
                                        }
                                      >
                                        <option value="">Select One</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="mb-3">
                                      <Label className="form-Label">Layout Type</Label>
                                      <select
                                        className="form-select"
                                        onChange={(e) =>
                                          filterDataHandle(e, "category", e.target.value)
                                        }
                                      >
                                        <option value="">Select One</option>
                                        {categories &&
                                          categories.map((item) => (
                                            <option key={item._id} value={item._id}>
                                              {item.layoutName}
                                            </option>
                                          ))}
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="mb-3">
                                      <Label className="form-label" htmlFor="formrow-phone-input">
                                        Property ID
                                      </Label>
                                      <Input
                                        type="text"
                                        placeholder="Enter a property ID"
                                        className="form-control"
                                        onChange={(e) => onchangetext(e, "propertyId")}
                                        id="formrow-phone-input"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="mb-3">
                                      <Label htmlFor="example-date-input" className="form-Label">
                                        From
                                      </Label>
                                      <Input
                                        className="form-control"
                                        type="date"
                                        onChange={(e) => setstartDate(e.target.value)}
                                        id="example-date-input"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-4">
                                    <div className="mb-3">
                                      <Label htmlFor="example-date-input2" className="form-Label">
                                        To
                                      </Label>
                                      <Input
                                        className="form-control"
                                        type="date"
                                        onChange={(e) => onchangetext(e, "To")}
                                        id="example-date-input2"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-12 searchClear-btns justify-content-end d-flex">
                                    <div className="srch-btn">
                                      <button type="submit" className="btn btn-primary">
                                        Search
                                      </button>
                                    </div>
                                    <div className="srch-btn">
                                      <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={() => window.location.reload()}
                                      >
                                        Clear
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </Form>
                            </div>
                          </CardBody>
                        </Card>
                      </Collapse>
                    </div>
                  </div>
                </CardHeader>

                <CardBody>
                  <div>
                    <select
                      onChange={(e) => handleSorting(e)}
                      style={{
                        borderRadius: "4px",
                        marginBottom: "10px",
                        borderColor: "#d1d1d5",
                      }}
                    >
                      <option>Sorting</option>
                      <option value={1}>A-Z</option>
                      <option value={2}>Z-A</option>
                      <option value={3}>Created Latest</option>
                      <option value={4}>Created Oldest</option>
                      <option value={5}>Modified Latest</option>
                      <option value={6}>Modified Oldest</option>
                    </select>
                  </div>

                  <Table className="table-striped table-bordered mb-0">
                    <thead>
                      <tr>
                        <th scope="col" style={{ maxWidth: "1rem" }}>#</th>
                        <th scope="col" style={{ minWidth: "12rem", maxWidth: "12rem" }}>Property</th>
                        <th scope="col" style={{ minWidth: "14rem", maxWidth: "14rem" }}>Layout</th>
                        <th scope="col" style={{ minWidth: "8rem", maxWidth: "8rem" }}>Owner / Manager</th>
                        <th scope="col" style={{ minWidth: "6em", maxWidth: "6rem" }}>City</th>
                        <th scope="col" style={{ minWidth: "14rem", maxWidth: "14rem" }}>Lease Documents</th>
                        <th scope="col" style={{ minWidth: "8rem", maxWidth: "8rem" }}>Created/Modified</th>
                        {["company"].includes(decode.role) ? (
                          <th scope="col">Action</th>
                        ) : null}
                      </tr>
                    </thead>
                    <tbody>
                      {totalproperties &&
                        totalproperties.map((item, index) => {
                          number++;
                          return (
                            <tr key={item._id}>
                              <td>{number + number1}</td>
                              <td>
                                <a
                                  href={`/rent_list/${item._id}`}
                                  onClick={() => tog_largee2()}
                                  data-toggle="modal"
                                  data-target=".bs-example-modal-lg"
                                >
                                  <strong className="text-muted" style={{ fontSize: "0.85rem" }}>
                                    {item.title}
                                  </strong>
                                  <br />
                                  <small>{item.primaryID}</small>
                                </a>
                              </td>
                              <td style={{ fontSize: "0.80rem" }}>
                                {item.layouts.map((cate) => cate.layoutName).join(", ")}
                              </td>
                              <td style={{ fontSize: "0.80rem", lineHeight: "1.4" }}>
                                <div>
                                  <span>Owner:</span>{" "}
                                  {item.owner || <span className="text-muted">N/A</span>}
                                </div>
                                <div>
                                  <span>Manager{item.managersList.length > 1 ? "s" : ""}:</span>{" "}
                                  {item.managersList.length > 0
                                    ? item.managersList
                                      .map((m) => `${m.firstname} ${m.lastname}`)
                                      .join(", ")
                                    : <span className="text-muted">N/A</span>}
                                </div>
                              </td>
                              <td style={{ fontSize: "0.80rem" }}>{item.location}</td>
                              <td style={{ fontSize: "0.75rem" }}>
                                {item.documents?.length > 0 && (
                                  <div className="mb-2">
                                    <Button
                                      color="link"
                                      id={`toggler-uploaded-${item._id}`}
                                      style={{ fontSize: "0.75rem", textDecoration: "none" }}
                                    >
                                      📁 Uploaded Documents
                                    </Button>
                                    <UncontrolledCollapse toggler={`#toggler-uploaded-${item._id}`}>
                                      <ul className="list-unstyled mb-2">
                                        {item.documents.map((doc) => (
                                          <li key={doc._id}>
                                            <button
                                              type="button"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                openDocPreview({ url: doc.url, fileName: doc.fileName });
                                              }}
                                              style={{
                                                background: "none",
                                                border: "none",
                                                padding: 0,
                                                color: "#007bff",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                                fontSize: "inherit",
                                                textAlign: "left",
                                              }}
                                            >
                                              📄 {doc.fileName}
                                            </button>
                                          </li>
                                        ))}
                                      </ul>
                                    </UncontrolledCollapse>
                                  </div>
                                )}
                                {item.documents_to_request?.length > 0 && (
                                  <div className="mb-2">
                                    <Button
                                      color="link"
                                      id={`toggler-request-${item._id}`}
                                      style={{ fontSize: "0.75rem", textDecoration: "none" }}
                                    >
                                      📝 Documents to Request
                                    </Button>
                                    <UncontrolledCollapse toggler={`#toggler-request-${item._id}`}>
                                      <ul className="list-unstyled mb-0">
                                        {item.documents_to_request.map((doc, index) => (
                                          <li key={index}>📝 {doc}</li>
                                        ))}
                                      </ul>
                                    </UncontrolledCollapse>
                                  </div>
                                )}
                                {!item.documents?.length && !item.documents_to_request?.length && (
                                  <span className="text-muted">No Documents</span>
                                )}
                              </td>
                              <td style={{ fontSize: "0.80rem" }}>
                                {moment(item.createdAt).format("YYYY-MM-DD")}/
                                {moment(item.modifiedAt).format("YYYY-MM-DD")}
                              </td>
                              {["company"].includes(decode.role) ? (
                                <td>
                                  <div className="d-flex gap-3">
                                    <i
                                      className="mdi mdi-delete font-size-18 text-danger"
                                      id="deletetooltip"
                                      onClick={async (e) => {
                                        e.preventDefault();
                                        setPropertyID(item._id);
                                        setShowDeleteDialoge(!showDeleteDialoge);
                                      }}
                                    ></i>
                                    <Modal
                                      isOpen={showDeleteDialoge}
                                      toggle={() => {
                                        setPropertyID("");
                                        setShowDeleteDialoge(!showDeleteDialoge);
                                      }}
                                    >
                                      <ModalHeader
                                        toggle={() => {
                                          setPropertyID("");
                                          setShowDeleteDialoge(!showDeleteDialoge);
                                        }}
                                      >
                                        Confirm
                                      </ModalHeader>
                                      <ModalBody>
                                        Are you sure you want to delete this?
                                      </ModalBody>
                                      <ModalFooter>
                                        <Button
                                          color="secondary"
                                          onClick={() => {
                                            setPropertyID("");
                                            setShowDeleteDialoge(!showDeleteDialoge);
                                          }}
                                        >
                                          Cancel
                                        </Button>
                                        <Button
                                          color="danger"
                                          onClick={async () => await deleteProperty()}
                                        >
                                          Delete
                                        </Button>
                                      </ModalFooter>
                                    </Modal>
                                    <i
                                      className="mdi mdi-border-color font-size-18"
                                      style={{ color: "black" }}
                                      onClick={async () => {
                                        seteditData(true);
                                        setPropertyID(item?._id);
                                        setTitle(item.title);
                                        setLocation(item.location);
                                        setStatus(item.status);
                                        setRent(item.rent_amount);
                                        setAddress(item?.address);
                                        setPostal(item?.postal_code);
                                        setLandload(item?.landlord);
                                        const prop = item?.layouts?.map((p) => ({
                                          label: p.layoutName,
                                          value: p._id,
                                        }));
                                        setCategory(prop);
                                        setmodal_large(!modal_large);
                                        removeBodyCss();
                                        getSuiteDetails(item?._id);
                                        getParkingDetails(item?._id);
                                        getStorageDetails(item?._id);
                                      }}
                                    ></i>
                                  </div>
                                </td>
                              ) : null}
                            </tr>
                          );
                        })}
                    </tbody>
                  </Table>

                  <Row className="proress-style mt-3">
                    <Col xl={3}></Col>
                    <Col xl={9}>
                      <div className="pagination-bar">
                        <Pagination>
                          <PaginationItem disabled={currentPage === 1}>
                            <PaginationLink first onClick={() => handlePageChange(1)} />
                          </PaginationItem>
                          <PaginationItem disabled={currentPage === 1}>
                            <PaginationLink
                              previous
                              onClick={() => handlePageChange(currentPage - 1)}
                            />
                          </PaginationItem>
                          {Array.from({ length: pageLimit }, (_, i) => i + startPage).map((p) => {
                            if (p > pageTotal) return null;
                            return (
                              <PaginationItem key={p} active={currentPage === p}>
                                <PaginationLink onClick={() => handlePageChange(p)}>
                                  {p}
                                </PaginationLink>
                              </PaginationItem>
                            );
                          })}
                          <PaginationItem disabled={currentPage === pageTotal}>
                            <PaginationLink
                              next
                              onClick={() => handlePageChange(currentPage + 1)}
                            />
                          </PaginationItem>
                          <PaginationItem disabled={currentPage === pageTotal}>
                            <PaginationLink
                              last
                              onClick={() => handlePageChange(pageTotal)}
                            />
                          </PaginationItem>
                        </Pagination>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* ─── Add / Edit Property Modal ─────────────────────────────────────── */}
      {modal_large && (
        <Modal
          size="xl"
          isOpen={modal_large}
          toggle={() => handleCloseModal()}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myLargeModalLabel">
              {editData ? "Edit" : "Add"} Property
            </h5>
            <button
              onClick={() => handleCloseModal()}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            {editData ? (
              <EditProperty
                propertyId={propertyID}
                onSuccess={() => {
                  handleCloseModal();
                  getProperties();
                }}
              />
            ) : (
              <Form onSubmit={addProperty}>
                <div className="row">
                  {/* Property Name */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="formrow-title-input">
                        Property Name *
                      </Label>
                      <Input
                        value={title}
                        placeholder="Enter a Property Name"
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value) {
                            setcheck_title(false);
                            setmsg_error("Property Name is required!");
                          } else if (!value.match(/^[a-zA-Z0-9 ]+$/)) {
                            setcheck_title(false);
                            setmsg_error("Only letters and numbers are allowed!");
                          } else {
                            setcheck_title(true);
                          }
                        }}
                        onChange={(e) => setTitle(e.target.value)}
                        type="text"
                        className="form-control"
                        id="formrow-title-input"
                      />
                      {!check_title && (
                        <Label style={{ color: "red" }}>{msg_error}</Label>
                      )}
                    </div>
                  </div>

                  {/* Landlord */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="formrow-landlord-input">
                        Landlord *
                      </Label>
                      <Input
                        value={landload}
                        placeholder="Enter a Landlord"
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value) {
                            setcheck_landload(false);
                            setmsg_error_landload("Landlord is required!");
                          } else {
                            setcheck_landload(true);
                          }
                        }}
                        onChange={(e) => setLandload(e.target.value)}
                        type="text"
                        className="form-control"
                        id="formrow-landlord-input"
                      />
                      {!check_landload && (
                        <Label style={{ color: "red" }}>{msg_error_landload}</Label>
                      )}
                    </div>
                  </div>

                  {/* Layouts */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="formrow-category-input">
                        Layouts *
                      </Label>
                      <Select
                        isMulti
                        value={category}
                        onBlur={() => {
                          if (category.length === 0) {
                            setcheck_layout(false);
                            setmsg_error2("Please select a Layout!");
                          } else {
                            setcheck_layout(true);
                          }
                        }}
                        onChange={(selectedOption) => setCategory(selectedOption)}
                        options={layout}
                        className="basic-multi-select"
                        classNamePrefix="select"
                      />
                      {!check_layout && (
                        <Label style={{ color: "red" }}>{msg_error2}</Label>
                      )}
                    </div>
                  </div>

                  {/* City */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="formrow-location-input">
                        City *
                      </Label>
                      <Input
                        value={location}
                        placeholder="Enter a city name"
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value) {
                            setcheck_city(false);
                            setmsg_error3("City is required!");
                          } else if (!value.match(/^[a-zA-Z0-9 ]+$/)) {
                            setcheck_city(false);
                            setmsg_error3("Only letters and numbers are allowed!");
                          } else {
                            setcheck_city(true);
                          }
                        }}
                        onChange={(e) => setLocation(e.target.value)}
                        type="text"
                        className="form-control"
                        id="formrow-location-input"
                      />
                      {!check_city && (
                        <Label style={{ color: "red" }}>{msg_error3}</Label>
                      )}
                    </div>
                  </div>

                  {/* Status */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Label className="form-Label">Status *</Label>
                      <select
                        value={status}
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value) {
                            setcheck_status(false);
                            setmsg_error4("Please select a Status!");
                          } else {
                            setcheck_status(true);
                          }
                        }}
                        onChange={(e) => setStatus(e.target.value)}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">In-active</option>
                      </select>
                      {!check_status && (
                        <Label style={{ color: "red" }}>{msg_error4}</Label>
                      )}
                    </div>
                  </div>

                  {/* Rent */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="formrow-rent-input">
                        Rent ($) *
                      </Label>
                      <Input
                        value={rent}
                        placeholder="Enter a rent"
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value) {
                            setcheck_rent(false);
                            setrent_error("Rent is required!");
                          } else if (!value.match(/^[0-9 ]+$/)) {
                            setcheck_rent(false);
                            setrent_error("Only numbers are allowed!");
                          } else {
                            setcheck_rent(true);
                          }
                        }}
                        onChange={(e) => setRent(e.target.value)}
                        type="text"
                        className="form-control"
                        id="formrow-rent-input"
                      />
                      {!check_rent && (
                        <Label style={{ color: "red" }}>{rent_error}</Label>
                      )}
                    </div>
                  </div>

                  {/* Postal Code */}
                  <div className="col-md-6">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="formrow-postal-input">
                        Postal code *
                      </Label>
                      <Input
                        value={postal}
                        placeholder="Enter postal code"
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value) {
                            setcheck_postal(false);
                            setpostal_error("Postal code is required!");
                          } else {
                            setcheck_postal(true);
                          }
                        }}
                        onChange={(e) => setPostal(e.target.value)}
                        type="text"
                        className="form-control"
                        id="formrow-postal-input"
                      />
                      {!check_postal && (
                        <Label style={{ color: "red" }}>{postal_error}</Label>
                      )}
                    </div>
                  </div>

                  {/* Address */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label htmlFor="basicpill-address-input" className="form-label">
                        Address *
                      </label>
                      <textarea
                        id="basicpill-address-input"
                        className="form-control"
                        rows="3"
                        value={address}
                        placeholder="Enter your address"
                        onBlur={(e) => {
                          const value = e.target.value;
                          if (!value) {
                            setcheck_address(false);
                            setaddress_error("Address is required!");
                          } else {
                            setcheck_address(true);
                          }
                        }}
                        onChange={(e) => setAddress(e.target.value)}
                      ></textarea>
                      {!check_address && (
                        <Label style={{ color: "red" }}>{address_error}</Label>
                      )}
                    </div>
                  </div>

                  {/* Suite Layout */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <button
                        disabled={suite}
                        type="button"
                        onClick={() => setSuite(true)}
                        className="btn btn-light"
                      >
                        <i className="bx bx-plus me-1"></i> Add Suite Layout
                      </button>
                    </div>
                  </div>

                  {suite && (
                    <>
                      <Row className="mb-3">
                        <Col md={6}>
                          <Label className="form-Label">Suite Type</Label>
                          <InputGroup>
                            <select
                              value={suiteType}
                              onChange={handleOnSelectSuiteType}
                              className="form-select"
                            >
                              {SUITE_TYPES.map((item, index) => (
                                <option key={index} value={item.value}>
                                  {item.value}
                                </option>
                              ))}
                            </select>
                            <Button color="info" onClick={handleAddSuiteType}>
                              Add
                            </Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      {suiteData.length > 0 &&
                        isSuiteAlphabet.length > 0 &&
                        suiteData.map((item, index) => (
                          <Card key={index}>
                            <CardHeader>
                              <Row>
                                <Col md={4}>
                                  <CardTitle>
                                    <Label className="form-Label"> Suite Type :</Label>{" "}
                                    {item.floorType}
                                  </CardTitle>
                                </Col>
                                <Col md={6}>
                                  <Row>
                                    <Col md={4}>
                                      <Label className="form-label">Suite Floor :</Label>
                                    </Col>
                                    <Col md={5}>
                                      <InputGroup>
                                        <Button
                                          color="info"
                                          disabled={item.floorCount <= FLOOR_LIMIT_FROM}
                                          onClick={() => handleDecreaseSuiteFloor(index)}
                                        >
                                          -
                                        </Button>
                                        <Input
                                          readOnly
                                          value={item.floorCount}
                                          type="text"
                                          className="form-control"
                                        />
                                        <Button
                                          color="info"
                                          disabled={item.floorCount >= FLOOR_LIMIT_TO}
                                          onClick={() => handleIncreaseSuiteFloor(index)}
                                        >
                                          +
                                        </Button>
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col md={2} className="text-end">
                                  <Button
                                    color="danger"
                                    onClick={() => handleRemoveSuiteType(index)}
                                  >
                                    Remove
                                  </Button>
                                </Col>
                              </Row>
                            </CardHeader>
                            <CardBody>
                              {item &&
                                isSuiteAlphabet[index]?.length > 0 &&
                                item.floors.map((_item, _index) => (
                                  <div
                                    key={_index}
                                    className="col-md-12"
                                    style={{
                                      padding: "10px",
                                      backgroundColor: "#00000017",
                                      borderRadius: "5px",
                                      marginBottom: "30px",
                                      marginTop: "15px",
                                    }}
                                  >
                                    <div className="d-flex floorNum">
                                      <h6>{_item.floor}</h6>
                                      <FormGroup className="alphabet_style">
                                        <Label className="me-3">Is Alphabet</Label>
                                        <Switch
                                          checked={isSuiteAlphabet[index][_index]}
                                          onChange={(value) => {
                                            if (isSuiteAlphabet.length > 0) {
                                              let _isAlphabet = isSuiteAlphabet.slice();
                                              _isAlphabet[index][_index] = value;
                                              setIsSuiteAlphabet(_isAlphabet);
                                            }
                                          }}
                                          onColor="#86d3ff"
                                          onHandleColor="#2693e6"
                                          handleDiameter={15}
                                          uncheckedIcon={false}
                                          checkedIcon={false}
                                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                          height={15}
                                          width={35}
                                          className="react-switch"
                                        />
                                      </FormGroup>
                                      <span>=</span>
                                      {isSuiteAlphabet.length > 0 &&
                                        isSuiteAlphabet[index][_index] && (
                                          <Input
                                            name="alphabet"
                                            placeholder="Select Alphabet"
                                            type="select"
                                            className="arrow-select"
                                            invalid={!_item.alphabet}
                                            valid={!!_item.alphabet}
                                            value={_item.alphabet}
                                            onChange={(e) =>
                                              handleOnSuiteChangeOnFloor(e, index, _index)
                                            }
                                          >
                                            <option value="">Select</option>
                                            {ALPHABET.map((a, ai) => (
                                              <option key={ai} value={a}>
                                                {a}
                                              </option>
                                            ))}
                                          </Input>
                                        )}
                                      <Input
                                        name="from"
                                        value={_item.from}
                                        placeholder="From"
                                        onChange={(e) =>
                                          handleOnSuiteChangeOnFloor(e, index, _index)
                                        }
                                        type="number"
                                        className="form-control floorFrom cmn_styleselct"
                                        invalid={!_item.from}
                                        valid={!!_item.from}
                                      />
                                      <Input
                                        name="to"
                                        value={_item.to}
                                        placeholder="To"
                                        onChange={(e) =>
                                          handleOnSuiteChangeOnFloor(e, index, _index)
                                        }
                                        type="number"
                                        className="form-control floorFrom cmn_styleselct"
                                        invalid={!_item.to}
                                        valid={!!_item.to}
                                      />
                                    </div>
                                  </div>
                                ))}
                            </CardBody>
                          </Card>
                        ))}
                    </>
                  )}

                  {/* ─── Documents Section (matches DocumentsHandler style) ─── */}
                  <div className="col-md-12">
                    <div className="mb-3">
                      <Label className="form-label" htmlFor="formrow-firstname-input">
                        Documents *
                      </Label>

                      {/* Dropzone */}
                      <Dropzone
                        onDrop={handleAcceptedFiles}
                        onDragEnter={() => setIsDragActive(true)}
                        onDragLeave={() => setIsDragActive(false)}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div
                            {...getRootProps()}
                            className={`border-2 border-dashed rounded-lg p-6 text-center transition-all duration-300 ease-in-out
                              ${isDragActive ? "border-blue-500 bg-blue-50" : "border-gray-300 hover:border-blue-400"}`}
                            style={{
                              border: isDragActive ? "2px dashed #3b82f6" : "2px dashed #d1d5db",
                              borderRadius: "8px",
                              padding: "24px",
                              textAlign: "center",
                              cursor: "pointer",
                              backgroundColor: isDragActive ? "#eff6ff" : "transparent",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <input {...getInputProps()} />
                            {selectedFiles.length === 0 && (
                              <div className="mb-3">
                                <i
                                  className="display-4 text-muted bx bxs-cloud-upload"
                                  style={{ fontSize: "3rem" }}
                                />
                              </div>
                            )}
                            <p style={{ color: isDragActive ? "#2563eb" : "#6b7280", margin: 0 }}>
                              {isDragActive
                                ? "Drop files here"
                                : "Drag and drop files or click to upload"}
                            </p>
                          </div>
                        )}
                      </Dropzone>

                      {/* Document Preview */}
                      {selectedFileForPreview && (
                        <div className="mt-3 border rounded" style={{ overflow: "hidden" }}>
                          <DocumentPreviewUI
                            documentUrl={
                              selectedFileForPreview.originalUrl ||
                              selectedFileForPreview.name
                            }
                            previewURL={selectedFileForPreview.preview}
                          />
                        </div>
                      )}

                      {/* File List with Edit / Preview / Remove buttons */}
                      <div className="dropzone-previews mt-3" id="file-previews">
                        {selectedFiles.map((f, i) => (
                          <Card
                            className="mt-1 mb-0 shadow-sm border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col>
                                  <div className="text-muted font-weight-bold">
                                    {getDisplayName(f)}
                                  </div>
                                  <p className="mb-0">
                                    <strong>{f.formattedSize || ""}</strong>
                                  </p>
                                </Col>
                                <Col className="col-auto d-flex">
                                  {/* Edit filename */}
                                  <Button
                                    color="info"
                                    size="sm"
                                    className="me-2"
                                    onClick={() => openEditModal(f, i)}
                                    title="Rename file"
                                  >
                                    <FeatherIcon icon="edit" size={16} />
                                  </Button>

                                  {/* Preview (only when previewable) */}
                                  {canPreviewFile(f) && (
                                    <Button
                                      color="primary"
                                      size="sm"
                                      className="me-2"
                                      onClick={() => handlePreviewFile(f)}
                                      title={
                                        selectedFileForPreview === f
                                          ? "Hide preview"
                                          : "Preview file"
                                      }
                                    >
                                      <FeatherIcon
                                        icon={
                                          selectedFileForPreview === f
                                            ? "eye-off"
                                            : "eye"
                                        }
                                        size={16}
                                      />
                                    </Button>
                                  )}

                                  {/* Remove */}
                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={() => handleRemoveFile(f)}
                                    title="Remove file"
                                  >
                                    <FeatherIcon icon="trash-2" size={16} />
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        ))}
                      </div>

                      {!check_document && (
                        <Label style={{ color: "red" }}>{msg_error1}</Label>
                      )}
                    </div>
                  </div>

                  {/* Save Button */}
                  <div className="col-md-12">
                    <div className="text-end">
                      <button
                        type="submit"
                        disabled={[
                          check_title,
                          check_rent,
                          check_layout,
                          check_city,
                          check_status,
                          check_postal,
                        ].includes(false)}
                        className="btn btn-success save-user"
                      >
                        Save
                        <i id="nexticon" className="bx bx-chevron-right ms-1"></i>
                        <div
                          id="saveSpinner"
                          style={{ display: "none", height: "15px", width: "15px", marginLeft: "5px" }}
                          className="spinner-border"
                          role="status"
                        ></div>
                        <i
                          id="failedSaveErrorIcon"
                          style={{ display: "none", marginLeft: "5px" }}
                          className="fa fa-exclamation-triangle"
                          aria-hidden="true"
                        ></i>
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </div>
        </Modal>
      )}

      {/* ─── Upload Logo Modal ────────────────────────────────────────────── */}
      {logoIsOpen && (
        <Modal isOpen={logoIsOpen} toggle={() => setLogoIsOpen(false)}>
          <ModalHeader toggle={() => setLogoIsOpen(false)}>Upload Logo</ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <img
                  src={
                    previewLogoUrl
                      ? previewLogoUrl
                      : updateLogoUrl
                        ? "data:image/jpeg;base64," + updateLogoUrl
                        : UploadLogo
                  }
                  alt="Logo"
                  style={{ maxWidth: "200px" }}
                />
              </Col>
              <hr />
              <Col md={12}>
                <Input
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  onChange={handleFileChange}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              disabled={!selectedLogo}
              color="primary"
              onClick={handleUploadLogo}
            >
              Upload
            </Button>
            <Button color="danger" onClick={() => setLogoIsOpen(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      )}

      {/* ─── Edit Filename Modal ──────────────────────────────────────────── */}
      <Modal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(!editModalOpen)}
      >
        <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
          Edit Filename
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="filename" className="form-label">
              File name:
            </label>
            <Input
              type="text"
              className="form-control"
              id="filename"
              value={editedFileName}
              onChange={(e) => setEditedFileName(e.target.value)}
            />
            <small className="form-text text-muted">
              The file extension will be preserved automatically.
            </small>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setEditModalOpen(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={saveEditedFileName}
            disabled={!editedFileName.trim()}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
      {/* ─── Table Document Preview Modal ────────────────────────────────── */}
      <Modal
        isOpen={docPreviewModal}
        toggle={closeDocPreview}
        size="xl"
        centered
      >
        <ModalHeader toggle={closeDocPreview}>
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            📄 {docPreviewItem?.fileName || "Document Preview"}
          </span>
        </ModalHeader>

        <ModalBody style={{ padding: 0, minHeight: "70vh", position: "relative" }}>
          {/* ── Loading state ── */}
          {docPreviewLoading && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "70vh",
                gap: "16px",
              }}
            >
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="text-muted mb-0">Loading preview…</p>
            </div>
          )}

          {/* ── Error state ── */}
          {!docPreviewLoading && docPreviewError && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "70vh",
                gap: "12px",
                padding: "24px",
              }}
            >
              <FeatherIcon icon="alert-circle" size={48} color="#dc3545" />
              <p className="text-danger text-center mb-0">{docPreviewError}</p>
            </div>
          )}

          {/* ── Preview ── */}
          {!docPreviewLoading && !docPreviewError && docPreviewSignedUrl && (
            <DocumentPreviewUI
              documentUrl={docPreviewItem.url}
              previewURL={docPreviewSignedUrl}
              height = "100vh"
            />
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            color="secondary"
            outline
            onClick={() => {
              // Prefer the signed URL for opening so auth tokens are included
              const target = docPreviewSignedUrl || docPreviewItem?.url;
              window.open(target, "_blank", "noopener,noreferrer");
            }}
          >
            <FeatherIcon icon="external-link" size={15} className="me-1" />
            Open in new tab
          </Button>
          <Button color="secondary" onClick={closeDocPreview}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default AddProperty;